import $ from 'jquery'
import LoginNav from './LoginNav'

$(document).ready(() => {
    new LoginNav()
})
